import React, { useState, useEffect, useRef, Suspense } from 'react';
import "./owl.setup";   // must be first
import { HelmetProvider } from 'react-helmet-async';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store';
import { persistStore, persistReducer } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
// import "owl.carousel/dist/owl.carousel";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '../src/Utility/Public/css/toastify.css';
import '../src/Utility/Public/css/theme.css';
import '../src/Utility/Public/css/_themevars.scss';
import './index.css';
import '../src/Utility/Public/css/common.scss';
import '../src/V1/Modules/Home/Assets/css/homedoc.scss';
import '../src/V1/Modules/Home/Assets/css/homeresponsivedoc.scss';
import '../src/V1/Modules/Booking/Assets/css/bookingdoc.scss';
import '../src/V1/Modules/Booking/Assets/css/bookingresponsivedoc.scss';
import '../src/V1/Modules/Payment/Assets/css/paymentdoc.scss';
import '../src/V1/Modules/Payment/Assets/css/paymentresponsivedoc.scss';
import '../src/GlobalModules/Login/Assets/css/logindoc.scss';
import '../src/GlobalModules/Login/Assets/css/loginresponsivedoc.scss';
import '../src/GlobalModules/UserProfile/Assets/css/profiledoc.scss';
import '../src/GlobalModules/UserProfile/Assets/css/profileresponsivedoc.scss';
import '../src/GlobalModules/FooterList/Assets/css/footerListdoc.scss';
import '../src/GlobalModules/FooterList/Assets/css/footerListresponsivedoc.scss';
import '../src/Utility/Public/css/headerdoc.scss';
import '../src/Utility/Public/css/headerresponsivedoc.scss';
import '../src/Utility/Public/css/font-awesome.css';
import 'react-datepicker/dist/react-datepicker.css';
import { ToastContainer } from 'react-toastify';
require("suneditor/dist/css/suneditor.min.css");

const root = ReactDOM.createRoot(document.getElementById('root'));
const persistor = persistStore(store);
root.render(
  <>
    <Provider store={store} >
      <PersistGate loading={null} persistor={persistor}>
        <HelmetProvider>
          <Suspense fallback={null}>
            <App />
          </Suspense>
        </HelmetProvider>
      </PersistGate>
    </Provider>
    <ToastContainer
      position="top-right"
      type="error"
      autoClose={4000}
      hideProgressBar={false}
      closeOnClick={true}
      pauseOnHover={true}
    />
  </>
);

reportWebVitals();
